// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var Js_json = require("rescript/lib/js/js_json.js");
var ReactDom = require("react-dom");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var LodashDebounce = require("lodash.debounce");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
var ReactUtils$SmartcutsMacros = require("../../bs-utils/src/ReactUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("./DOM__Element.bs.js");

var containerId = "highlight-controls";

function t_encode(v) {
  if (v) {
    return ["CaptureScreenshotIntoClipboard"];
  } else {
    return ["RecordClickCommand"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CaptureScreenshotIntoClipboard" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CaptureScreenshotIntoClipboard */1
                  };
          }
      case "RecordClickCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RecordClickCommand */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(callback) {
  if (callback) {
    return "CaptureScreenshotIntoClipboard";
  } else {
    return "RecordClickCommand";
  }
}

function fromString(string) {
  switch (string) {
    case "CaptureScreenshotIntoClipboard" :
        return /* CaptureScreenshotIntoClipboard */1;
    case "RecordClickCommand" :
        return /* RecordClickCommand */0;
    default:
      return ;
  }
}

var Callback = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromString: fromString
};

function calculateStyleOfHighlightBox(htmlElement) {
  var domRect = htmlElement.getBoundingClientRect();
  return CssJs.style([
              CssJs.position("fixed"),
              CssJs.top({
                    NAME: "px",
                    VAL: domRect.top | 0
                  }),
              CssJs.left({
                    NAME: "px",
                    VAL: domRect.left | 0
                  }),
              CssJs.boxSizing("contentBox"),
              CssJs.border({
                    NAME: "px",
                    VAL: 1
                  }, "dashed", {
                    NAME: "hex",
                    VAL: "000"
                  }),
              CssJs.padding("zero"),
              CssJs.margin("zero"),
              CssJs.background({
                    NAME: "rgba",
                    VAL: [
                      80,
                      140,
                      232,
                      {
                        NAME: "num",
                        VAL: 0.25
                      }
                    ]
                  }),
              CssJs.width({
                    NAME: "px",
                    VAL: domRect.width | 0
                  }),
              CssJs.height({
                    NAME: "px",
                    VAL: domRect.height | 0
                  }),
              CssJs.display("block"),
              CssJs.cursor("pointer"),
              CssJs.zIndex(10000)
            ]);
}

function maybeKeepTargetElement(targetElement) {
  var container = document.getElementById(containerId);
  if (container == null) {
    return ;
  }
  if (container.contains(targetElement) || container === targetElement) {
    return ;
  }
  var arg = Webapi__Dom__HtmlElement.ofElement(targetElement);
  var param = Belt_Option.flatMap(DOM__Element$SmartcutsMacros.closest((function (element) {
              return Belt_Option.isSome(Webapi__Dom__HtmlElement.ofElement(element));
            }), targetElement), Webapi__Dom__HtmlElement.ofElement);
  return OptionUtils$SmartcutsMacros.orElse(param, arg);
}

function registerListenerForHighlightElement(setState) {
  var onMouseOver = function (domEvent) {
    var targetElement = domEvent.target;
    var targetElement$1 = maybeKeepTargetElement(targetElement);
    if (targetElement$1 === undefined) {
      return ;
    }
    var targetElement$2 = Caml_option.valFromOption(targetElement$1);
    return Curry._1(setState, (function (state) {
                  return {
                          maybeElementToHighlight: Caml_option.some(targetElement$2),
                          maybeDetachListeners: state.maybeDetachListeners
                        };
                }));
  };
  var debouncedClearHighlightElement = LodashDebounce((function (param) {
          return Curry._1(setState, (function (state) {
                        return {
                                maybeElementToHighlight: undefined,
                                maybeDetachListeners: state.maybeDetachListeners
                              };
                      }));
        }), 20);
  var onMouseMove = function (_domEvent) {
    return Curry._1(debouncedClearHighlightElement, undefined);
  };
  document.addEventListener("mouseover", onMouseOver, true);
  document.addEventListener("mousemove", onMouseMove, true);
  return function (param) {
    document.removeEventListener("mouseover", onMouseOver, true);
    document.removeEventListener("mousemove", onMouseMove, true);
    
  };
}

function calculateStyleForAlias(htmlElement) {
  var domRect = htmlElement.getBoundingClientRect();
  return CssJs.style([
              CssJs.position(CssJs.fixed),
              CssJs.top(CssJs.px(Math.max(0, (domRect.top | 0) - 19 | 0))),
              CssJs.left(CssJs.px(Math.max(0, (domRect.left | 0) - 1 | 0))),
              CssJs.lineHeight(CssJs.px(18)),
              CssJs.color(CssJs.hex("fff")),
              CssJs.backgroundColor(CssJs.hex("0BC0CC")),
              CssJs.whiteSpace(CssJs.nowrap),
              CssJs.overflow(CssJs.visible),
              CssJs.padding2(CssJs.zero, CssJs.px(2)),
              CssJs.cursor(CssJs.pointer)
            ]);
}

function textForLabelFromHtmlElement(label, htmlElement) {
  var tagName = htmlElement.nodeName;
  var classNames = htmlElement.className;
  var classNames$1 = classNames === "" ? "" : "." + classNames.replace(new RegExp("\\s"), ".");
  var id = htmlElement.id;
  var id$1 = id === "" ? "" : "#" + id;
  return tagName + (id$1 + classNames$1);
}

function HighlightElement__Shared$HighlightElementControl$HighlightLabel(Props) {
  var htmlElement = Props.htmlElement;
  var label = Props.label;
  var alias = textForLabelFromHtmlElement(label, htmlElement);
  return React.createElement("div", {
              className: calculateStyleForAlias(htmlElement)
            }, ReactUtils$SmartcutsMacros.s(alias));
}

var HighlightLabel = {
  make: HighlightElement__Shared$HighlightElementControl$HighlightLabel
};

function HighlightElement__Shared$HighlightElementControl(Props) {
  var onSelectElement = Props.onSelectElement;
  var withLabel = Props.withLabel;
  var match = React.useState(function () {
        return {
                maybeElementToHighlight: undefined,
                maybeDetachListeners: undefined
              };
      });
  var setState = match[1];
  var match$1 = match[0];
  var maybeDetachListeners = match$1.maybeDetachListeners;
  var maybeElementToHighlight = match$1.maybeElementToHighlight;
  React.useEffect((function () {
          var detachListeners = registerListenerForHighlightElement(setState);
          Curry._1(setState, (function (state) {
                  return {
                          maybeElementToHighlight: state.maybeElementToHighlight,
                          maybeDetachListeners: detachListeners
                        };
                }));
          return (function (param) {
                    if (maybeDetachListeners !== undefined) {
                      return Curry._1(maybeDetachListeners, undefined);
                    }
                    
                  });
        }), []);
  if (maybeElementToHighlight === undefined) {
    return null;
  }
  var htmlElement = Caml_option.valFromOption(maybeElementToHighlight);
  return React.createElement("div", {
              className: calculateStyleOfHighlightBox(htmlElement),
              onClick: (function (_event) {
                  return Curry._1(onSelectElement, htmlElement);
                })
            }, withLabel !== undefined ? React.createElement(HighlightElement__Shared$HighlightElementControl$HighlightLabel, {
                    htmlElement: htmlElement,
                    label: withLabel
                  }) : null);
}

var HighlightElementControl = {
  HighlightLabel: HighlightLabel,
  make: HighlightElement__Shared$HighlightElementControl
};

function renderHighlightElementControl(onSelectElement, withLabel, param) {
  var arg = Webapi__Dom__Document.asHtmlDocument(document);
  var htmlDocument = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect htmlDocument while renderHighlightElementControl");
  var arg$1 = htmlDocument.body;
  var arg$2 = (arg$1 == null) ? undefined : Caml_option.some(arg$1);
  var body = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
      })("Expect body while renderHighlightElementControl");
  var containerThatWasAlreadyOnPage = document.getElementById(containerId);
  var container;
  if (containerThatWasAlreadyOnPage == null) {
    var newContainer = document.createElement("div");
    newContainer.id = containerId;
    body.appendChild(newContainer);
    container = newContainer;
  } else {
    container = containerThatWasAlreadyOnPage;
  }
  var tmp = {
    onSelectElement: (function (htmlElement) {
        body.removeChild(container);
        return Curry._1(onSelectElement, htmlElement);
      })
  };
  if (withLabel !== undefined) {
    tmp.withLabel = Caml_option.valFromOption(withLabel);
  }
  ReactDom.render(React.createElement(HighlightElement__Shared$HighlightElementControl, tmp), container);
  
}

var doNotShowExplainModalStorageKey = "doNotShowModalToExplainHighlightElement";

exports.containerId = containerId;
exports.doNotShowExplainModalStorageKey = doNotShowExplainModalStorageKey;
exports.Callback = Callback;
exports.HighlightElementControl = HighlightElementControl;
exports.renderHighlightElementControl = renderHighlightElementControl;
/* CssJs Not a pure module */
